/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: calc(12rem /14);
  display: block;
  height: calc(18rem /14);
  flex: 0 0 auto;
}
:host #icon {
  top: calc(1rem/14);
  margin-top: calc(-9rem/14);
  height: calc(14rem/14);
  width: calc(14rem/14);
}
:host svg {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}
:host .breadcrumb-item {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  text-decoration: none;
  background-color: transparent;
  line-height: calc(18rem /14);
  font-size: calc(12rem /14);
  font-weight: bold;
  margin: 0 calc(2rem /14) 0 calc(2rem /14);
}
:host .breadcrumb-item:hover {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}

:host(:focus) {
  outline: none;
}

:host a {
  border-bottom: 1px solid transparent;
}
:host a:focus {
  outline: none;
  border-bottom: 1px solid var(--davinci-color-outline-light,#C5CACC);
}

:host([hidden]) {
  display: none;
}

:host(:first-child) #icon {
  display: none;
}
:host(:first-child) .breadcrumb-item {
  margin-left: 0;
}

:host(:last-child) .breadcrumb-item {
  font-weight: normal;
  cursor: default;
  margin-right: 0;
  pointer-events: none;
}
:host(:last-child) .breadcrumb-item:hover {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}`;
export { style };
